"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var _a = React.createContext(''),
    Consumer = _a.Consumer,
    Provider = _a.Provider;

exports.NameSpaceConsumer = Consumer;

var NamespaceProvider = function NamespaceProvider(_a) {
  var ns = _a.ns,
      children = _a.children;
  return React.createElement(Provider, {
    value: ns
  }, " ", children, " ");
};

exports.default = NamespaceProvider;